import { clientVaLaunch } from "../config/client_api_calls";

// Shared by the login flow (Pages/Client/Login/index.js) and the
// authenticated app shell (components/Client/main.js) so the VoiceAlerts
// Login Redirect flag is enforced at every authenticated entry point, not
// just the one-time login submit - otherwise the browser Back button or
// reopening a tab lands back on the OBS dashboard instead of VA (reported
// live, 2026-10-09). client_va_launch re-checks the flag itself server-side
// on every call - no local pre-check here, and no caching: each call mints a
// fresh, short-lived VA session via the existing SSO handoff, which also
// transparently covers an expired VA session needing a new one. Returns
// true if the redirect fired (caller should stop/skip its own normal
// rendering), false otherwise (flag off, call failed, or session invalid -
// callers fall through to their existing behavior either way).
// client_api_calls.js's axios wrapper never resolves/rejects on a genuine
// non-2xx response (no .catch on its promise chain - a known, pre-existing
// gap, see docs/environment.md) - e.g. the backend's own rate limiter
// returns a real HTTP 429. Harmless when this only ran once at login, but
// this now runs on every authenticated mount, so a bounded timeout keeps a
// stuck call from hanging the whole dashboard load instead of just skipping
// the redirect for that one page view.
//
// 2026-10-14: raised 5s -> 30s. A client's FIRST launch (e.g. right after
// email verification) creates their VoiceAlerts key, registers it with VA
// (up to V1_VA_TIMEOUT_MS) and makes two Admin Portal calls, which routinely
// exceeded 5s - the race then gave up and showed the OBS dashboard, while the
// second login (key already provisioned, fast) redirected correctly. The
// timeout is still only a ceiling for a hung server: callers keep the page
// blank (main.js vaCheckPending) while waiting, and every normal call
// resolves in well under a second.
const VA_CHECK_TIMEOUT_MS = 30000;

export async function redirectToVoiceAlertsIfEnabled(accountno, token) {
  try {
    const r = await Promise.race([
      clientVaLaunch(accountno, token),
      new Promise((resolve) => setTimeout(() => resolve(null), VA_CHECK_TIMEOUT_MS)),
    ]);
    const data = r && r.data && r.data.data;
    if (!data || !data.enabled) return false;
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.action_url;
    form.style.display = "none";
    Object.entries(data.fields || {}).forEach(([k, v]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = k;
      input.value = v;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return true;
  } catch (e) {
    return false;
  }
}
